import { AfterViewInit, Directive, ElementRef, EventEmitter, Input, NgZone, Output } from "@angular/core";

export class Options {
  bounds?: any;
  componentRestrictions?: any;
  types?: string[];
  fields?: string[];
  strictBounds?: boolean;
  origin?: any;

  constructor(opt?: Partial<Options>) {
    if (opt) Object.assign(this, opt);
  }
}

export class Address {
  address_components!: any[];
  adr_address!: string;
  formatted_address!: string;
  formatted_phone_number!: string;
  geometry!: any;
  html_attributions!: string[];
  icon!: string;
  id!: string;
  international_phone_number!: string;
  name!: string;
  opening_hours!: any;
  permanently_closed!: boolean;
  photos!: any[];
  place_id!: string;
  price_level!: number;
  rating!: number;
  reviews!: any[];
  types!: string[];
  url!: string;
  utc_offset!: number;
  vicinity!: string;
  website!: string;
}

@Directive({
    selector: "[ngx-google-places-autocomplete]",
    exportAs: "ngx-places",
    standalone: false
})
export class GooglePlaceDirective implements AfterViewInit {
  @Input() options!: Options;
  @Output() onAddressChange = new EventEmitter<any>();

  place: any;
  private autocomplete: any;

  constructor(private el: ElementRef, private ngZone: NgZone) {}

  ngAfterViewInit(): void {
    if (!this.options) this.options = new Options();
    this.initialize();
  }

  private isGoogleLibExists(): boolean {
    const g = (window as any)["google"];
    return !!g?.maps?.places;
  }

  private initialize(): void {
    if (!this.isGoogleLibExists()) {
      console.warn("Google maps library not found");
      return;
    }
    const google = (window as any)["google"];
    this.autocomplete = new google.maps.places.Autocomplete(this.el.nativeElement, this.options);
    if (this.autocomplete?.addListener) {
      this.autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          this.place = this.autocomplete.getPlace();
          if (this.place) {
            this.onAddressChange.emit(this.place);
          }
        });
      });
    }
    this.el.nativeElement.addEventListener("keydown", (event: KeyboardEvent) => {
      if (!event.key) return;
      if (event.key.toLowerCase() === "enter" && event.target === this.el.nativeElement) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
    if (window?.navigator?.userAgent && navigator.userAgent.match(/(iPad|iPhone|iPod)/g)) {
      setTimeout(() => {
        const containers = document.getElementsByClassName("pac-container");
        if (containers) {
          Array.from(containers).forEach((container) => {
            container.addEventListener("touchend", (e) => e.stopImmediatePropagation());
          });
        }
      }, 500);
    }
  }

  reset(): void {
    this.autocomplete?.setComponentRestrictions(this.options?.componentRestrictions);
    this.autocomplete?.setTypes(this.options?.types);
  }
}
